import { useEffect, useState, useRef } from "react";
import { InputGroup, FormControl, Container, Button, Dropdown, DropdownButton, Form, Col, Row, Spinner, OverlayTrigger, Tooltip, Toast, ToastContainer } from 'react-bootstrap';
import './PageContainer.scss';


function PageContainer({ children }) {

    const PageContentRef = useRef(null);
    const [scrollTopPosition, setScrollTopPosition] = useState(0);

    useEffect(() => {

    }, []);

    const scrollToTop = () => {
        PageContentRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest',
        });
    }

    function onScrollChange(e) {
        setScrollTopPosition(e.target.scrollTop)
    }

    return (
        <div id="PageContainer" onScroll={onScrollChange}>
            <span className={"scrollBtn bg-white border shadow text-gray-800 cursor-pointer hover-bg-gray-300 " + (scrollTopPosition > 800 ? ' showScrollBtn' : ' hideScrollBtn')} onClick={() => scrollToTop()}>
                <i className="material-icons">keyboard_double_arrow_up</i>
            </span>
            <div className="h-100" ref={PageContentRef}>
                {children}
            </div>
        </div>
    )
}

export { PageContainer };
